import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Spinner,
  Offcanvas,
  OffcanvasHeader,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import toast from "react-hot-toast";
import CustomerTypeService from "../../../services/OrderingServices/CustomerTypeService";
import CustomerMetaFieldService from "../../../services/OrderingServices/CustomerMetaFieldService";
import Select from "react-select";

// Validation Schema
const validationSchema = Yup.object({
  // username: Yup.string().required("Username is required"),
  firstName: Yup.string().required("First name is required"),
  // lastName: Yup.string().required("Last name is required"),
  // email: Yup.string()
  //   .email("Invalid email address")
  //   .matches(
  //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //     "Enter a valid email address"
  //   )
  //   .required("Email is required"),
  // address: Yup.string().required("Address is required"),
  phoneNo: Yup.string()
    .required("Phone number is required")
    .matches(/^[0-9]+$/, "Phone number must be digits only")
    .min(10, "Phone number must be at least 10 digits")
    .max(10, "Phone number must be exactly 10 digits"),
  customerTypeId: Yup.number().nullable().required("Customer type is required"),
});

const MobileCustomerForm = ({
  selectedCustomer,
  modal,
  toggleModal,
  fetchCustomers,
  onCustomerAdded,
}) => {
  const [loading, setLoading] = useState(false);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [activeMetaFields, setActiveMetaFields] = useState([]);

  const fetchCustomerType = async () => {
    try {
      const response = await CustomerTypeService.getList();
      setCustomerTypeData(response.items || []);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMetaFields = async () => {
    try {
      const response = await CustomerMetaFieldService.getList();
      const items = Array.isArray(response) ? response : response?.items || [];
      setActiveMetaFields(items.filter((field) => field.isActive));
    } catch (error) {
      console.error("Error fetching meta fields:", error);
    }
  };

  useEffect(() => {
    fetchCustomerType();
    fetchMetaFields();
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedCustomer?.id || "",

      // username: selectedCustomer?.username || "",
      firstName: selectedCustomer?.firstName || "",
      lastName: selectedCustomer?.lastName || "",
      email: selectedCustomer?.email || "",
      address: selectedCustomer?.address || "Kathmandu",
      phoneNo: selectedCustomer?.phoneNo
        ? String(selectedCustomer.phoneNo)
        : "9800000000",
      customerTypeId: selectedCustomer?.customerTypeId || null,
      customerMetaValues: activeMetaFields.map((field) => {
        const existing = selectedCustomer?.customerMetaValues?.find(
          (m) => m.metaFieldCode === field.code,
        );
        return {
          metaFieldCode: field.code,
          value: existing ? existing.value : "",
        };
      }),
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        const payload = {
          ...values,
          customerMetaValues: values.customerMetaValues
            .filter((m) => m.value.trim() !== "") // Optional: filter out empty ones? The user said "show all and input value and post", usually we post all or just those with values. I'll post all as per the structure they showed.
            .map((m) => ({
              metaFieldCode: m.metaFieldCode,
              value: m.value,
            })),
        };

        if (values.id) {
          await CustomerServices.update(values.id, payload);
          toast.success("Customer updated successfully.");
        } else {
          const newCustomer = await CustomerServices.create(payload);
          toast.success("New customer is added successfully");
          resetForm();
          if (onCustomerAdded) onCustomerAdded(newCustomer);
          toggleModal();
        }
        fetchCustomers();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      } finally {
        setLoading(false);
      }
    },
  });
  // Reset form when modal closes
  useEffect(() => {
    if (!modal) {
      formik.resetForm();
    }
  }, [modal]);
  const handleCustomerTypeChange = (selectedOption) => {
    formik.setFieldValue(
      "customerTypeId",
      selectedOption ? selectedOption.value : null
    );
  };

  const customerTypeOptions = customerTypeData
    .filter((type) => type.isActive) // only active
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const selectedCustomerType = customerTypeOptions.find(
    (option) => option.value === formik.values.customerTypeId
  );

  useEffect(() => {
    // Only for NEW customer (not edit)
    if (
      !selectedCustomer?.id &&
      customerTypeOptions.length > 0 &&
      formik.values.customerTypeId === null
    ) {
      formik.setFieldValue("customerTypeId", customerTypeOptions[0].value);
    }
  }, [customerTypeOptions, selectedCustomer]);



  const handleMetaValueChange = (code, value) => {
    const updated = formik.values.customerMetaValues.map((m) =>
      m.metaFieldCode === code ? { ...m, value } : m,
    );
    formik.setFieldValue("customerMetaValues", updated);
  };

  return (
    <Offcanvas
      isOpen={modal}
      toggle={toggleModal}
      direction="end"
      backdrop={true}
      scrollable
      style={{ width: "min(420px, 100vw)" }}
    >
      <OffcanvasHeader toggle={toggleModal} className="border-bottom p-3">
        <i className="bx bx-plus me-2"></i>{" "}
        {selectedCustomer?.id ? "Edit Customer" : "Add Customer"}
      </OffcanvasHeader>
      <Form
        onSubmit={formik.handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          overflow: "hidden",
        }}
      >
        {/* Scrollable form content */}
        <div
          style={{
            flex: "1 1 auto",
            overflowY: "auto",
            padding: "1rem",
          }}
        >
          {/* First Name */}
          <div className="mb-2">
            <Label className="fw-bold mb-2">First Name</Label>
            <Input
              id="firstName"
              name="firstName"
              type="text"
              className="form-control shadow-sm"
              placeholder="First Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
              invalid={
                !!(formik.touched.firstName && formik.errors.firstName)
              }
            />
            {formik.touched.firstName && formik.errors.firstName && (
              <FormFeedback type="invalid">
                {formik.errors.firstName}
              </FormFeedback>
            )}
          </div>

          {/* Last Name */}
          <div className="mb-2">
            <Label className="fw-bold mb-2">Last Name</Label>
            <Input
              id="lastName"
              name="lastName"
              type="text"
              className="form-control shadow-sm"
              placeholder="Last Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
              invalid={!!(formik.touched.lastName && formik.errors.lastName)}
            />
            {formik.touched.lastName && formik.errors.lastName && (
              <FormFeedback type="invalid">
                {formik.errors.lastName}
              </FormFeedback>
            )}
          </div>

          {/* Email */}
          <div className="mb-2">
            <Label className="fw-bold mb-2">Email</Label>
            <Input
              id="email"
              name="email"
              type="email"
              className="form-control shadow-sm"
              placeholder="Enter email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              invalid={!!(formik.touched.email && formik.errors.email)}
            />
            {formik.touched.email && formik.errors.email && (
              <FormFeedback type="invalid">
                {formik.errors.email}
              </FormFeedback>
            )}
          </div>

          {/* Address */}
          <div className="mb-2">
            <Label className="fw-bold mb-2">Address</Label>
            <Input
              id="address"
              name="address"
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.address}
              invalid={!!(formik.touched.address && formik.errors.address)}
            />
            {formik.touched.address && formik.errors.address && (
              <FormFeedback type="invalid">
                {formik.errors.address}
              </FormFeedback>
            )}
          </div>

          {/* Phone Number */}
          <div className="mb-2">
            <Label className="fw-bold mb-2">Phone Number</Label>
            <Input
              id="phoneNo"
              name="phoneNo"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control shadow-sm"
              placeholder="Enter phone number"
              value={formik.values.phoneNo}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                formik.setFieldValue("phoneNo", onlyNums);
              }}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.phoneNo && formik.errors.phoneNo)}
            />
            {formik.touched.phoneNo && formik.errors.phoneNo && (
              <FormFeedback type="invalid">
                {formik.errors.phoneNo}
              </FormFeedback>
            )}
          </div>

          {/* Customer Type */}
          <div className="mb-2">
            <Label className="fw-bold mb-2">Customer Type</Label>
            <Select
              id="customerTypeId"
              name="customerTypeId"
              options={customerTypeOptions}
              value={selectedCustomerType || null}
              onChange={handleCustomerTypeChange}
              placeholder="Select Customer Type"
              isClearable
              className={
                formik.touched.customerTypeId && formik.errors.customerTypeId
                  ? "is-invalid"
                  : ""
              }
            />
            {formik.touched.customerTypeId &&
              formik.errors.customerTypeId && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                >
                  {formik.errors.customerTypeId}
                </div>
              )}
          </div>
<hr className="border-secondary my-4"/>
          {/* Customer Meta Fields */}
          {activeMetaFields.length > 0 && (
            <div className="mt-3">
              <Label className="fw-bold mb-3">Customer Meta Fields</Label>
              {activeMetaFields.map((field) => {
                const metaValue =
                  formik.values.customerMetaValues.find(
                    (m) => m.metaFieldCode === field.code,
                  )?.value || "";

                return (
                  <div key={field.id} className="mb-3">
                    <Label className="small fw-bold text-muted mb-1">
                      {field.title}
                    </Label>
                    <Input
                      type="text"
                      className="form-control shadow-sm"
                      placeholder={`Enter ${field.title}`}
                      value={metaValue}
                      onChange={(e) =>
                        handleMetaValueChange(field.code, e.target.value)
                      }
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* FOOTER BUTTONS — always pinned at bottom */}
        <div
          className="bg-white border-top d-flex justify-content-between gap-2"
          style={{
            flex: "0 0 auto",
            padding: "0.75rem 1rem",
          }}
        >
          <Button
            color="danger"
            onClick={toggleModal}
            className="w-50 border shadow-sm"
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className="w-50 shadow-sm"
            type="submit"
            disabled={loading}
          >
            {loading && <Spinner size="sm" className="me-2" />}
            {loading
              ? selectedCustomer?.id
                ? "Updating..."
                : "Creating..."
              : selectedCustomer?.id
              ? "Update"
              : "Create"}
          </Button>
        </div>
      </Form>
    </Offcanvas>
  );
};

export default MobileCustomerForm;
